
import { useMediaQuery } from '@material-ui/core';

export const useMedia = () => {
    const breakpoints = {
        ls: 320,
        xs: 640,
        sm: 768,
        md: 1024,
        lg: 1200,
        blg: 2000,
    }

    const mbsMatches = useMediaQuery(`(max-width:${breakpoints.ls}px)`);
    const mbxsMatches = useMediaQuery(`(max-width:${breakpoints.xs}px)`);
    const mbMatches = useMediaQuery(`(max-width:${breakpoints.sm}px)`);
    const mdMatches = useMediaQuery(`(min-width:${breakpoints.xs+1}px) and (max-width:${breakpoints.sm}px)`)
    const tlMatches = useMediaQuery(`(min-width:${breakpoints.sm+1}px) and (max-width:${breakpoints.md}px)`);
    const minWebMatches = useMediaQuery(`(min-width:${breakpoints.md+1}px) and (max-width:${breakpoints.lg}px)`);
    const webMatches = useMediaQuery(`(min-width:${breakpoints.lg}px)`);
    const bigWebMatches = useMediaQuery(`(min-width:${breakpoints.blg}px)`);

    /**
     * if need media class
     * Mobile Media [className className-mb]
     * Tablet Media [className className-mb]
     * Web Media [className]
     * 
     * if excludeType
     * no need to matches current Media
     * 
     * *** scss add the same className ***
     * 
     * @param className 
     * @param excludeType todo 排除非必要ClassName
     * @returns 
     */
    const mediaClass = (className: string, exMatches?: string[]) => {
        const renewClassName = className;

        if (exMatches && exMatches.length) {
            if (mbsMatches && exMatches.includes('mbls')) {return renewClassName}
            if (mbxsMatches && exMatches.includes('mbxs')) {return renewClassName}
            if (mbMatches && exMatches.includes('mb')) {return renewClassName}
            if (tlMatches && exMatches.includes('tl')) {return renewClassName}
            if (minWebMatches && exMatches.includes('mw')) {return renewClassName}
            if (webMatches && exMatches.includes('web')) {return renewClassName}
            if (bigWebMatches && exMatches.includes('bw')) {return renewClassName}
        }
        
        if (mbsMatches) {return `${renewClassName} ${renewClassName}-mb ${renewClassName}-ms`}
        if (mbxsMatches) {return `${renewClassName} ${renewClassName}-mb ${renewClassName}-xs`}
        if (mbMatches) {return `${renewClassName} ${renewClassName}-mb`}
        if (tlMatches) {return `${renewClassName} ${renewClassName}-tl`}
        if (minWebMatches) {return `${renewClassName} ${renewClassName}-mw`}
        if (bigWebMatches) {return `${renewClassName} ${renewClassName}-bw`}
        if (webMatches) {return renewClassName}

        return renewClassName
    }


    return {
        mbsMatches,
        mbxsMatches,
        mbMatches,
        tlMatches,
        minWebMatches,
        webMatches,
        mdMatches,
        bigWebMatches,
        mediaClass,
    }
}
